import { render, staticRenderFns } from "./NotificationListAll.vue?vue&type=template&id=371e4cfb&scoped=true"
import script from "./NotificationListAll.vue?vue&type=script&lang=js"
export * from "./NotificationListAll.vue?vue&type=script&lang=js"
import style0 from "./NotificationListAll.vue?vue&type=style&index=0&id=371e4cfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371e4cfb",
  null
  
)

export default component.exports